import { Component, OnInit } from "@angular/core";
import { Event, Router, NavigationStart, NavigationEnd } from "@angular/router";
import { PlatformLocation } from "@angular/common";
import { IdleService } from "./idle.service";
import { SessionValidatorService } from "./core/service/session-validator.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  currentUrl: string;

  private readonly AUTH_ROUTES = ['/authentication/', '/auth/'];

  constructor(
    private idleService: IdleService,
    public _router: Router,
    location: PlatformLocation,
    private sessionValidator: SessionValidatorService
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }

      if (routerEvent instanceof NavigationEnd) {
        const isAuthPage = this.AUTH_ROUTES.some(r => routerEvent.urlAfterRedirects.includes(r));
        if (isAuthPage) {
          this.idleService.stopTimer();
        } else {
          this.idleService.resetTimer();
        }
      }

      window.scrollTo(0, 0);
    });
  }

  ngOnInit() {
    this.sessionValidator.validateSession();
  }
}
